import { Types } from '../../../actions/dashboards'
import { Metrics } from '../../../constants/Dashboards'
import buildAsyncStatReducer from './asyncStatReducer'

/**
 * Eventspace Content Top
 */
const eventspaceContentTop = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_CONTENT_TOP,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.request,
        success: Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.success,
        failure: Types.DASHBOARD_EVENTSPACE_CONTENT_TOP.failure,
    },
    transform: (state, { payload }) => {
        const { link, count } = payload[0] || {}
        return { link, count }
    },
})

/**
 * Eventspace Dwell Timeline reducer
 */
const eventspaceDwellTimeline = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_DWELLTIMELINE,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.request,
        success: Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.success,
        failure: Types.DASHBOARD_EVENTSPACE_DWELLTIMELINE.failure,
    },
    transform: (state, { payload }) =>
        Object.keys(payload || {}).reduce((carry, date) => {
            return [
                ...carry,
                {
                    moment: date,
                    time: payload[date],
                },
            ]
        }, []),
})

/**
 * Eventspace Interactions
 */
const eventspaceInteractions = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_INTERACTIONS,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_INTERACTIONS.request,
        success: Types.DASHBOARD_EVENTSPACE_INTERACTIONS.success,
        failure: Types.DASHBOARD_EVENTSPACE_INTERACTIONS.failure,
    },
    transform: (state, { payload }) => {
        const { count = 0 } = payload[0] || {}
        return count
    },
})

/**
 * Eventspace Interactions (Grouped)
 */
const eventspaceInteractionsGrouped = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_INTERACTIONS_GROUPED,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.request,
        success: Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.success,
        failure: Types.DASHBOARD_EVENTSPACE_INTERACTIONS_GROUPED.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ type: interactionType, count: interactionCount }) => ({
            type: interactionType,
            count: interactionCount,
        }))
    },
})

/**
 * Eventspace Products Top
 */
const eventspaceProductsTop = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_PRODUCTS_TOP,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.request,
        success: Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.success,
        failure: Types.DASHBOARD_EVENTSPACE_PRODUCTS_TOP.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ sku, count }) => ({
            sku,
            count,
        }))
    },
})

/**
 * Eventspace Stores Top
 */
const eventspaceStoresTop = buildAsyncStatReducer({
    key: Metrics.EVENTSPACE_STORES_TOP,
    types: {
        request: Types.DASHBOARD_EVENTSPACE_STORES_TOP.request,
        success: Types.DASHBOARD_EVENTSPACE_STORES_TOP.success,
        failure: Types.DASHBOARD_EVENTSPACE_STORES_TOP.failure,
    },
    transform: (state, { payload }) => {
        return payload.map(({ store_code: storeCode, count }) => ({
            storeCode,
            count,
        }))
    },
})

const eventspaceReducers = [
    eventspaceContentTop,
    eventspaceDwellTimeline,
    eventspaceInteractions,
    eventspaceInteractionsGrouped,
    eventspaceProductsTop,
    eventspaceStoresTop,
]

export default eventspaceReducers
